/** The page types a capabilities assessment can hold. */
export const CAPABILITY_QUESTIONS_PAGE_TYPE = 'capability-questions';
export const STANDARD_QUESTIONS_PAGE_TYPE = 'standard-questions';

/**
 * Any other type (one removed or renamed, say) is an unknown page: the editor
 * shows it so it can be deleted, it blocks launch, and participants and
 * results never see it.
 */
export const KNOWN_PAGE_TYPES = Object.freeze([
  CAPABILITY_QUESTIONS_PAGE_TYPE,
  STANDARD_QUESTIONS_PAGE_TYPE,
]);
